import { useInfiniteQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { axios, queryClient } from '@apps-common/lib'
import { IUnitActivationFilter } from '@apps-common/stores'
import { IActivationServiceRequestModel } from '@apps-common/types/portal/service-request'

export const QUERY_SEARCH_UNIT_ACTIVATIONS_INFINITE = (searchTerm?: string, status?: string, take?: number, skip?: number) =>
  ['getActivationsInfinite', searchTerm, status, take].filter(Boolean)

export const getActivationsInfinite = async (
  searchTerm: string,
  status: string,
  skip: number,
  take: number
): Promise<IActivationServiceRequestModel[]> =>
  axios
    .get(`/UnitActivation/SearchUnitActivationRequests?searchTerm=${searchTerm}&status=${status}&skip=${skip}&take=${take}`)
    .then((res) => res.data?.data)

type Props = {
  config?: any
  model: IUnitActivationFilter
}

export const useSearchUnitActivationsInfinite = ({ config, model }: Props) => {
  const { isLoading, isFetching, isRefetching, isError, data, refetch, fetchNextPage } = useInfiniteQuery({
    ...(config || {}),
    queryKey: QUERY_SEARCH_UNIT_ACTIVATIONS_INFINITE(model.searchVal, model.statusVal, model.take, model.skip),
    initialPageParam: 0,
    queryFn: ({ pageParam = 0 }) => getActivationsInfinite(model.searchVal, model.statusVal, pageParam as number, model.take),
    getNextPageParam: (lastPage, allPages) => allPages?.reduce((acc, curr) => acc + (curr?.length || 0), 0)
  })

  useEffect(
    () => () => {
      queryClient.removeQueries({ queryKey: QUERY_SEARCH_UNIT_ACTIVATIONS_INFINITE() })
    },
    []
  )

  return { isLoading, isFetching, isRefetching, isError, data, refetch, fetchNextPage }
}
